import { memo } from 'react';
import { API_PATH } from '@zmedia/bm-soccer-ui/service/ContentService';
import { ContentMoreSection } from '@zmedia/bm-soccer-ui/modules/content';
import { TitleHeader } from '@zmedia/bm-soccer-ui/modules/shared/components/TitleHeader';
import { TitleWrap } from '@zmedia/bm-soccer-ui/modules/shared/components/TitleWrap';
import styles from './style.module.scss';

export function ContentSection(props: any) {
    const { contents = [], listProps } = props;
    const options = {
        url: API_PATH.GET_LIST,
        params: {
            query: props.name,
            listType: 'byQuery',
            page: contents.length > 0 ? 2 : 1,
        },
    };
    return (
        <ContentMoreSection
            className={styles['content-overview-section']}
            items={contents}
            options={options}
            listProps={listProps}
        >
            <TitleHeader>
                <TitleWrap
                    renderAs="h2"
                    title={'Tin Tức ' + props.name}
                ></TitleWrap>
            </TitleHeader>
        </ContentMoreSection>
    );
}

export default memo(ContentSection);
